import type { TeamOld } from '@getaccept/lib-shared/src/users/types/team-old';
import { useQuery } from '@tanstack/vue-query';
import { computed } from 'vue';
import { UserService } from '../../api/users/services/user.service';
import type { User } from '../../user/types/user';
import { usersKeys } from '../users-key-factory';

export const useUsers = () => {
  const {
    data,
    isSuccess,
    isPending: isLoading,
    isError,
  } = useQuery({
    queryKey: usersKeys.usersList(),
    queryFn: () => UserService.load(),
  });

  const teams = computed(() => {
    const uniqueTeams: TeamOld[] = data.value.reduce((acc: TeamOld[], user: User) => {
      if (!user.team) {
        return acc;
      }
      const accHasTeam: boolean = acc.some((team: TeamOld) => team.id === user.team.id);
      if (accHasTeam) {
        return acc;
      }
      return [...acc, user.team];
    }, []);
    return uniqueTeams.map((team: TeamOld) => ({
      ...team,
      users: data.value.filter((user: User) => user.team?.id === team.id),
    }));
  });
  const usersWithoutTeam = computed(() => data.value.filter((user: User) => !user.team));

  return { data, isSuccess, isError, isLoading, teams, usersWithoutTeam };
};
